
define('text!templates/parts/menu/context-menu-item.html',[],function () { return '<li>{{^empty}}<a {{#id}}id="{{id}}"{{/id}} href="{{route}}">{{#t}}{{caption}}{{/t}}{{#icon}} <span class="icon {{icon}}"></span>{{/icon}}</a>{{/empty}}</li>\n';});

